import en from "./locales/en/app.json";
import fr from "./locales/fr/app.json";

export const resources = { fr, en };
